import React, { useState, useEffect } from 'react';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from '../../util/reactIntl';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { getPosts } from '../../util/api.js';

import { LayoutSingleColumn, PrimaryButton } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer.js';
import FooterContainer from '../FooterContainer/FooterContainer.js';

import CreatePostForm from './CreatePostForm/CreatePostForm.js';
import BlogFeed from './BlogFeed/BlogFeed.js';
import StaticPage from '../PageBuilder/StaticPage.js';

import css from './BlogPage.module.css';

const BlogPageComponent = (props) => {
    const {
        intl,
        currentUser,
        onManageDisableScrolling,
    } = props;

    const [postOpen, setPostOpen] = useState(false);
    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(false);

    const postToEdit = postOpen && postOpen !== true
        ? posts.find(p => p._id == postOpen)
        : null;

    const pageMetaProps = {
        "title": intl.formatMessage({ id: 'BP.meta.title' }),
        "description": intl.formatMessage({ id: 'General.meta.text' }),
        "schema": {
            "@context": "http://schema.org",
            "@type": "Article",
            "description": intl.formatMessage({ id: 'General.meta.text' }),
            "name": intl.formatMessage({ id: 'BP.meta.title' }),
            "headline": intl.formatMessage({ id: 'BP.meta.title' }),
        },
        "socialSharing": {
            "title": intl.formatMessage({ id: 'BP.meta.title' }),
            "description": intl.formatMessage({ id: 'General.meta.text' }),
            "images1200": null,
            "images600": null
        },
    };

    const isAdmin = !!currentUser?.attributes?.profile?.metadata?.isAdmin;

    const onGetPosts = () => {
        setLoading(true);
        getPosts({})
            .then(res => {
                setPosts(res);
            })
            .catch(() => {
                alert("Failed to load posts.")
            })
            .finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        onGetPosts();
    }, []);

    return <StaticPage className={css.root} {...pageMetaProps}>
        <LayoutSingleColumn
            topbar={<TopbarContainer currentPage="BlogPage" />}
            footer={<FooterContainer />}
        >
            <div as="main" className={css.main}>
                {isAdmin ? <div className={css.welcome}>
                    <div>
                        <h2 className={css.welcomeTitle}>
                            <FormattedMessage id="BP.welcome.title" />
                        </h2>
                        <p className={css.welcomeText}>
                            <FormattedMessage id="BP.welcome.text1" />
                        </p>
                        <p className={css.welcomeText}>
                            <FormattedMessage id="BP.welcome.text2" />
                        </p>

                        <PrimaryButton
                            className={css.createPostBtn}
                            type="button"
                            onClick={() => setPostOpen(true)}
                        >
                            Create a post
                        </PrimaryButton>
                    </div>

                    {postOpen ? <CreatePostForm
                        postOpen={postOpen}
                        setPostOpen={setPostOpen}
                        onAddPost={(post) => setPosts([
                            post,
                            ...posts,
                        ])}
                        postToEdit={postToEdit}
                        posts={posts}
                        setPosts={setPosts}
                        onManageDisableScrolling={onManageDisableScrolling}
                    /> : null}
                </div> : null}
                <div className={css.feed}>
                    <BlogFeed
                        loading={loading}
                        posts={posts}
                        setPosts={setPosts}
                        isAdmin={isAdmin}
                        onEditPost={(id) => setPostOpen(id)}
                    />
                </div>
            </div>
        </LayoutSingleColumn>
    </StaticPage>
};

const mapStateToProps = state => {
    const { currentUser } = state.user;

    return {
        currentUser,
    };
};

const mapDispatchToProps = dispatch => ({
    onManageDisableScrolling: (componentId, disableScrolling) =>
        dispatch(manageDisableScrolling(componentId, disableScrolling)),
});

const BlogPage = compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    injectIntl,
)(BlogPageComponent);

export default BlogPage;
